// Stripe draws the card field in its own iframe, which cannot read our CSS variables, so the
// dark colours are shadcn's neutral foreground and muted-foreground as plain hex.
const COLORS = {
  light: { background: 'white', color: '#382b2f', muted: '#c0b6ba' },
  dark: { background: 'transparent', color: '#fafafa', muted: '#a1a1a1' },
};

export default function getCardElementOptions(appliedTheme = 'light') {
  const { background, color, muted } = COLORS[appliedTheme] ?? COLORS.light;
  return {
    style: {
      base: {
        iconColor: muted,
        fontWeight: 400,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
        fontSmoothing: 'antialiased',
        background,
        fontSize: '16px',
        lineHeight: '1.5',
        padding: '8px',
        color,
        '::placeholder': {
          color: muted,
        },
        '::focus-visible': {
          outline: 'none',
        },
      },
    },
  };
}
